import { PrintDataEntitas } from "@/domain/entities/Booking";
import jsPDF from "jspdf";
import * as watermarks from "@/app/ui/modules/receipt-v2/constants/watermarks-v2";


export const getWaterMark = async (params: {
  doc: jsPDF;
  bookingType: string;
  accountType: string;
  data: PrintDataEntitas;
  pieceData: any;
  barcode: string;
  vendorRefCode: string;
  barcodeValue: string;
  vendorRefCodeValue: string;
  logo: string;
  shipmentId: string;
  startX: number;
  startY: number;
}) => {
  const isSpecialProduct =
    params.data.sttProductType.toUpperCase() === "BOSSPACK" ||
    params.data.sttProductType.toUpperCase() === "SAMEDAY" ||
    params.data.sttProductType.toUpperCase() === "VIPPACK" ||
    params.data.sttProductType.toUpperCase() === "INTERPACKMAXI";
  let result = "";
  const prefixProduct = params.data.sttProductType.toLowerCase();
  if (isSpecialProduct) {
    if (params.data.sttIsCod && !params.data.sttIsDfod) {
      result = params.data.isDangerousGoods && params.data.sttCommodityIsQuarantine
        ? `${prefixProduct}_cod_dg_k`
        : params.data.isDangerousGoods
        ? `${prefixProduct}_cod_dg`
        : params.data.sttCommodityIsQuarantine
        ? `${prefixProduct}_cod_k`
        : `${prefixProduct}_cod`;
    } else if (params.data.sttIsDfod) {
      result = params.data.isDangerousGoods && params.data.sttCommodityIsQuarantine
        ? `${prefixProduct}_dfod_dg_k`
        : params.data.isDangerousGoods
        ? `${prefixProduct}_dfod_dg`
        : params.data.sttCommodityIsQuarantine
        ? `${prefixProduct}_dfod_k`
        : `${prefixProduct}_dfod`;
    } else if (params.data.isDangerousGoods && params.data.sttCommodityIsQuarantine) {
      result = `${prefixProduct}_dg_k`;
    } else if (params.data.isDangerousGoods) {
      result = `${prefixProduct}_dg`;
    } else if (params.data.sttCommodityIsQuarantine) {
      result = `${prefixProduct}_k`;
    } else {
      result = prefixProduct;
    }
  } else {
    if (params.data.sttIsCod && !params.data.sttIsDfod) {
      result = params.data.isDangerousGoods && params.data.sttCommodityIsQuarantine
        ? "cod_dg_k"
        : params.data.isDangerousGoods 
        ? "cod_dg"
        : params.data.sttCommodityIsQuarantine
        ? "cod_k" 
        : "cod";
    } else if (params.data.sttIsDfod) {
      result = params.data.isDangerousGoods && params.data.sttCommodityIsQuarantine
        ? "dfod_dg_k"
        : params.data.isDangerousGoods 
        ? "dfod_dg"
        : params.data.sttCommodityIsQuarantine
        ? "dfod_k" 
        : "dfod";
    } else if (params.data.isDangerousGoods && params.data.sttCommodityIsQuarantine) {
      result = "dg_k";
    } else if (params.data.isDangerousGoods) {
      result = "dg";
    } else if (params.data.sttCommodityIsQuarantine) {
      result = "k";
    }
  }

  if (params.data.isPriorityTier) {
    result = result == "" ? "prioritas" : `prioritas_${result}`;
  }


  const camelToSnake = (str: string) =>
    str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

  const watermarkMaps: Record<string, string> = Object.fromEntries(
    Object.entries(watermarks).map(([key, value]) => [
      camelToSnake(key),
      value as string,
    ])
  );

  let watermark: string | undefined;

  if (result) {
    if (watermarkMaps[result]) {
      watermark = watermarkMaps[result];
    } else {
      const module = await import(
        `@/app/ui/assets/images/watermark-v2/${result}.png`
      );
      watermark = module.default;
    }
  }

  if (result && watermark) {
    return params.doc.addImage(
      watermark,
      "PNG",
      params.startX,
      params.startY,
      104,
      144,
      `${result}`,
      "FAST"
    );
  }
};
